export const VIEWPORT_MARGIN = 8;

export interface VerticalPlacementInput {
    triggerTop: number;
    triggerBottom: number;
    viewportHeight: number;
    preferUp: boolean;
    estimatedHeight: number;
    offset: number;
}

export interface VerticalPlacement {
    top?: number;
    bottom?: number;
    placement: 'top' | 'bottom';
    maxHeight: number;
}

export function placeVertically({
    triggerTop,
    triggerBottom,
    viewportHeight,
    preferUp,
    estimatedHeight,
    offset
}: VerticalPlacementInput): VerticalPlacement {
    const roomBelow = viewportHeight - triggerBottom - offset - VIEWPORT_MARGIN;
    const roomAbove = triggerTop - offset - VIEWPORT_MARGIN;
    const openUp = preferUp
        ? roomAbove >= roomBelow
        : roomBelow < estimatedHeight && roomAbove > roomBelow;
    if (openUp) {
        return {
            bottom: Math.max(VIEWPORT_MARGIN, viewportHeight - triggerTop + offset),
            placement: 'top',
            maxHeight: roomAbove
        };
    }
    return {
        top: Math.min(triggerBottom + offset, viewportHeight - VIEWPORT_MARGIN),
        placement: 'bottom',
        maxHeight: roomBelow
    };
}
